import React, { ReactNode } from 'react';
import styles from './Button.module.scss';
import LoadingButton from '@material-ui/lab/LoadingButton';
import MuiButton from '@material-ui/core/Button';
import cx from 'classnames';

export type Props = {
  children?: ReactNode;
  className?: string;
  onClick?: (event: any) => void;
  type?: 'button' | 'submit' | 'reset' | undefined;
  variant?: 'primary' | 'success' | 'warning' | 'danger';
  buttonVariant?: 'contained' | 'text';
  isLoading?: boolean;
  isLoadingButton?: boolean;
  isConfirmationButton?: boolean;
  isSaveButton?: boolean;
  color?: 'primary' | 'secondary';
  startIcon?: string | ReactNode;
  endIcon?: string | ReactNode;
  isDisabled?: boolean;
  isActive?: boolean;
  disableRipple?: boolean;
};

const Button = ({
  children,
  className,
  onClick,
  type,
  variant,
  isLoading,
  isLoadingButton,
  isConfirmationButton,
  color,
  buttonVariant,
  endIcon,
  startIcon,
  isSaveButton,
  isDisabled,
  isActive,
  disableRipple,
}: Props) => {
  if (isLoadingButton) {
    return (
      <LoadingButton
        className={cx(styles.button, styles.simpleButton, className)}
        onClick={onClick}
        variant={buttonVariant ?? 'contained'}
        color={color}
        loading={isLoading}
        loadingPosition="end"
        endIcon={endIcon}
        type={type}
        disabled={isDisabled}
        startIcon={startIcon}
      >
        {children}
      </LoadingButton>
    );
  }

  if (isSaveButton) {
    return (
      <LoadingButton
        className={cx(styles.button, styles.saveButton, className)}
        onClick={onClick}
        variant={buttonVariant ?? 'contained'}
        color={color}
        loading={isLoading}
        loadingPosition="end"
        endIcon={endIcon}
        type={type}
        disabled={isDisabled}
      >
        {children}
      </LoadingButton>
    );
  }

  if (isConfirmationButton) {
    return (
      <MuiButton
        className={cx(styles.button, styles.simpleButton)}
        onClick={onClick}
        variant={'text'}
        color={color}
        startIcon={startIcon}
        disabled={isLoading}
      >
        {children}
      </MuiButton>
    );
  }

  return (
    <MuiButton
      className={cx(
        styles.button,
        styles.simpleButton,
        {
          [styles.textButton]: buttonVariant === 'text',
          [styles.isActive]: isActive,
        },
        className,
      )}
      onClick={onClick}
      variant={buttonVariant ?? 'contained'}
      color={color}
      startIcon={startIcon}
      disabled={isDisabled}
      disableRipple={disableRipple}
    >
      {children}
    </MuiButton>
  );
};

Button.defaultProps = {
  variant: 'primary',
  onClick: () => {},
  isLoading: false,
};

export default Button;
